import config from '~/config';

const recaptcha = (type) => window&&window.grecaptcha&&window.grecaptcha.enterprise.execute ? grecaptcha.enterprise.execute(config.grecaptchaKey, {action: type}): Promise.resolve("")

export default recaptcha


// WEBPACK FOOTER //
// ./src/misc/recaptcha.js